import React, { useEffect } from "react";
import { Button } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import AppLayout from "../../Components/Styles/AppLayout";
import ContentLayout from "../../Components/Styles/ContentLayout";
import Header from "../../Components/Common/Header";
import { useSelector } from "react-redux";

const useStyles = createStyles(() => ({
  outerWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "2rem 1rem",
  },
  link: {
    marginTop: "21.5px",
  },
}));

const UpdateSuccess = () => {
  const { classes } = useStyles();

  const { config, language } = useSelector((state) => ({
    config: state.config,
    language: state.language,
  }));

  const baseUrl = new URL(config.apiUri).origin;

  useEffect(() => {
    if (config && language) {
      document.title = `${language.language.Subscription_Update_Header} - ${config.shopName}`;
    }
  }, [config, language]);

  return (
    <AppLayout pageName="update-success">
      <Header hideUser={true} config={config} language={language} />
      <ContentLayout>
        <main className={classes.outerWrapper} id="main-page-content">
          <h1>Betalkort uppdaterat</h1>
          <p>Ditt gamla betalkort är nu bortkopplat från abonnemanget</p>
          <p>
            Det nya betalkortet kommer att användas vid nästa dragningstillfälle
          </p>
          <Button
            component="a"
            href={`${baseUrl}/members`}
            className={`${classes.link} primaryButton`}
          >
            Tillbaka till Mina sidor
          </Button>
        </main>
      </ContentLayout>
    </AppLayout>
  );
};

export default UpdateSuccess;
